import { render, staticRenderFns } from "./AddComment.vue?vue&type=template&id=09b95544&scoped=true"
import script from "./AddComment.vue?vue&type=script&lang=js"
export * from "./AddComment.vue?vue&type=script&lang=js"
import style0 from "./AddComment.vue?vue&type=style&index=0&id=09b95544&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b95544",
  null
  
)

export default component.exports